import { render, staticRenderFns } from "./madeCategry.vue?vue&type=template&id=1389b912&scoped=true"
import script from "./madeCategry.vue?vue&type=script&lang=js"
export * from "./madeCategry.vue?vue&type=script&lang=js"
import style0 from "./madeCategry.vue?vue&type=style&index=0&id=1389b912&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1389b912",
  null
  
)

export default component.exports